import { render, staticRenderFns } from "./product-resource-item-2-product-statistics.vue?vue&type=template&id=eb9ebd98&"
import script from "./product-resource-item-2-product-statistics.vue?vue&type=script&lang=ts&"
export * from "./product-resource-item-2-product-statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports